import{jsxs as o,jsx as n}from"react/jsx-runtime";import{useNavigate as e,Link as i}from"react-router-dom";import{styled as r}from"styled-components";import{CompanySwitch as t}from"./CompanySelect.mjs";import{logout as a}from"../repositories/logout.mjs";import{useTry as l}from"../../../hooks/useTry.mjs";import{useItemNames as m}from"../../../../domain/hooks/useItemName.mjs";import{linkName as s}from"../../../../domain/domain/UI/Link.name.mjs";const p=r.div`
  width: 545px;
  height: 22px;
  margin-top: 10px;
  margin-right: 12px;
  float: left;
  position: absolute;
  top: 0px;
  left: 630px;
`,d=r.ul`
  font-size: 85%;
  margin: 0;
  padding: 0px 3px;
  list-style-type: none;
  float: right;
`,c=r.li`
  display: inline;
  margin: 0px 3.5px;
  padding-left: 16px;
  background: url('images/link.png') no-repeat scroll left center transparent;
  vertical-align: middle;
  &.no-link {
    background: none;
  }
`,f=r(i)`
  color: #f0f0f0;
  text-decoration: none;
  cursor: pointer;

  &:visited {
    color: #f0f0f0;
  }
  &:hover {
    color: #f0f0f0;
    text-decoration: underline;
  }
`;function h({subSystemName:i,needCompanySwitch:r=!0}){const{wrapRequestInTry:h}=l(),g=e(),u=m(s),x=h((async()=>{await a(),g("/login")}));return o(p,{className:"navigation",children:[o(d,{id:"header-navigation",children:[r&&n(c,{className:"no-link",children:n(t,{})}),n(c,{children:n(f,{to:`/${i}/main-menu`,children:u("mainMenu")})}),n(c,{children:n(f,{to:"/help",children:u("help")})}),n(c,{children:n(f,{to:"/change-password",id:"change-password-link",children:u("changePassword")})}),n(c,{children:n(f,{id:"logout",to:"/login",onClick:async o=>{o.preventDefault(),await x()},children:u("logout")})})]}),n("br",{})]})}export{h as Navigation};
